import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { UserPermissionAddSchema } from "../../../ValidationSchema";
import ReactSelect from "../../../Components/PortalSelect";
import DesignationModal from "./designation";
import "./um.css";

// react-select themed to the design tokens (light + dark)
const colourStyles = {
  control: (styles, state) => ({
    ...styles,
    minHeight: 42,
    backgroundColor: "var(--color-surface)",
    borderColor: state.isFocused ? "var(--color-primary)" : "var(--color-border)",
    borderRadius: 10,
    boxShadow: state.isFocused ? "0 0 0 3px var(--color-primary-weak)" : "none",
    "&:hover": { borderColor: "var(--color-primary)" },
  }),
  menu: (styles) => ({
    ...styles,
    backgroundColor: "var(--color-surface)",
    border: "1px solid var(--color-border)",
    zIndex: 30,
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "var(--color-primary-weak)",
    borderRadius: 8,
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "var(--color-primary)",
    fontWeight: 700,
    fontSize: 12,
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "var(--color-primary)",
    borderRadius: 8,
    ":hover": { backgroundColor: "var(--color-hover)", color: "var(--color-primary)" },
  }),
  singleValue: (styles) => ({ ...styles, color: "var(--color-text-primary)" }),
  input: (styles) => ({ ...styles, color: "var(--color-text-primary)" }),
  placeholder: (styles) => ({ ...styles, color: "var(--color-text-tertiary)" }),
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isFocused ? "var(--color-hover)" : "var(--color-surface)",
    color: "var(--color-text-primary)",
    ":active": { backgroundColor: "var(--color-hover)" },
  }),
};

const UserManagementAdd = () => {
  const Navigate = useNavigate();
  const [initialValues] = useState({
    name: "",
    email: "",
    mobile_number: "",
    designation: "",
    role_id: 0,
    module_id: [],
    sub_module_id: [],
    permission_id: [],
  });

  const [showDesignationModal, setShowDesignationModal] = useState(false);

  // Hardcoded designation data
  const [designationData] = useState([
    { value: "graphics_designer", label: "Graphic Designer" },
    { value: "sales_executive", label: "Sales Executive" },
  ]);

  // Hardcoded module data
  const [moduleData] = useState([
    { label: "Dashboard", value: 1 },
    { label: "User Management", value: 2 },
    { label: "Buyer Management", value: 3 },
    { label: "Supplier Management", value: 4 },
    { label: "Design Studio", value: 5 },
    { label: "Assigned Orders", value: 6 },
    { label: "GD Management", value: 7 },
    { label: "Master", value: 8 },
  ]);

  // Hardcoded submodule data
  const [allSubModuleData] = useState([
    { sub_module_id: 1, module_id: 1, name: "Dashboard" },
    { sub_module_id: 2, module_id: 2, name: "User Management" },
    { sub_module_id: 3, module_id: 3, name: "Buyer Lead" },
    { sub_module_id: 4, module_id: 3, name: "Request Quotation" },
    { sub_module_id: 5, module_id: 3, name: "Supplier Buy Lead" },
    { sub_module_id: 6, module_id: 4, name: "Supplier" },
    { sub_module_id: 7, module_id: 4, name: "Connection" },
    { sub_module_id: 8, module_id: 4, name: "Product" },
    { sub_module_id: 9, module_id: 5, name: "Design Studio" },
    { sub_module_id: 10, module_id: 6, name: "Assigned Orders" },
    { sub_module_id: 11, module_id: 7, name: "List" },
    { sub_module_id: 12, module_id: 8, name: "Product" },
    { sub_module_id: 13, module_id: 8, name: "Category" },
    { sub_module_id: 14, module_id: 8, name: "Sub Category" },
    { sub_module_id: 15, module_id: 8, name: "Blog" },
    { sub_module_id: 16, module_id: 8, name: "Blog Category" },
    { sub_module_id: 17, module_id: 8, name: "RFQs" },
    { sub_module_id: 18, module_id: 8, name: "Consultations" },
    { sub_module_id: 19, module_id: 7, name: "Connection" },
  ]);

  const [subModuleData, setSubModuleData] = useState([]);
  const [selectedModulesWithSubmodules, setSelectedModulesWithSubmodules] =
    useState({});

  const handleAddDesignation = (newOption) => {};

  // Function to structure modules data for API
  const structureModulesData = (moduleIds, subModuleIds) => {
    const modulesMap = {};

    // Group submodules by their module_id
    subModuleIds.forEach((subModuleId) => {
      const subModule = allSubModuleData.find(
        (item) => item.sub_module_id === subModuleId
      );
      if (subModule) {
        if (!modulesMap[subModule.module_id]) {
          modulesMap[subModule.module_id] = [];
        }
        modulesMap[subModule.module_id].push(subModuleId);
      }
    });

    // Only include modules that are selected and have submodules
    const modules = moduleIds
      .filter(
        (moduleId) => modulesMap[moduleId] && modulesMap[moduleId].length > 0
      )
      .map((moduleId) => ({
        module_id: moduleId,
        sub_module_ids: modulesMap[moduleId],
      }));

    return modules;
  };

  const AddSubCategory = useFormik({
    initialValues,
    validationSchema: UserPermissionAddSchema,

    onSubmit: (values, action) => {
      // Structure the modules data according to API requirements
      const modulesData = structureModulesData(
        values.module_id,
        values.sub_module_id
      );

      // Prepare the data for submission according to API structure
      const submitData = {
        name: values.name,
        email: values.email,
        phone: values.mobile_number, // Changed from mobile_number to phone
        designation: values.designation,
        modules: modulesData,
      };

      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/sub_admin_module_permissions`,
          submitData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/UserManagement/list", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg || "Error submitting data");
          console.error("Submission error:", err);
        });
    },
  });

  useEffect(() => {
    // Filter submodules based on selected module_id(s)
    if (AddSubCategory.values.module_id.length > 0) {
      const filteredSubModules = allSubModuleData
        .filter((item) =>
          AddSubCategory.values.module_id.includes(item.module_id)
        )
        .map((item) => ({
          label: item?.name || "Untitled",
          value: item?.sub_module_id,
        }));

      setSubModuleData(filteredSubModules);

      // Also filter out any selected submodules that are no longer in the filtered list
      const currentSubModules = AddSubCategory.values.sub_module_id;
      const validSubModules = currentSubModules.filter((subModuleId) =>
        filteredSubModules.some((item) => item.value === subModuleId)
      );

      if (validSubModules.length !== currentSubModules.length) {
        AddSubCategory.setFieldValue("sub_module_id", validSubModules);
      }
    } else {
      setSubModuleData([]);
      // Clear submodules if no modules are selected
      if (AddSubCategory.values.sub_module_id.length > 0) {
        AddSubCategory.setFieldValue("sub_module_id", []);
      }
    }
  }, [AddSubCategory.values.module_id, allSubModuleData]);

  const f = AddSubCategory;
  const err = (k) =>
    f.errors[k] && f.touched[k] ? (
      <span className="um-err">{f.errors[k]}</span>
    ) : null;

  return (
    <div className="um">
      <Toaster position="top-center" reverseOrder={false} />

      <form onSubmit={f.handleSubmit}>
        {/* page header */}
        <div className="um-head">
          <div>
            <h1 className="um-title">Add Sub Admin</h1>
            <p className="um-sub">
              Create a new sub-admin account and assign module access.
            </p>
          </div>
          <button type="button" className="um-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Back
          </button>
        </div>

        {/* Account Details */}
        <div className="um-card">
          <div className="um-card__head">
            <span className="um-card__icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </span>
            <div>
              <h3 className="um-card__title">Account Details</h3>
              <p className="um-card__sub">Basic login credentials for the new sub-admin.</p>
            </div>
          </div>
          <div className="um-card__body um-grid">
            <div className="um-field">
              <label className="um-label">Name <span className="um-req">*</span></label>
              <input
                className="um-input"
                type="text"
                placeholder="Enter full name"
                name="name"
                value={f.values.name}
                onChange={f.handleChange}
                onBlur={f.handleBlur}
              />
              {err("name")}
            </div>
            <div className="um-field">
              <label className="um-label">Email <span className="um-req">*</span></label>
              <input
                className="um-input"
                type="text"
                placeholder="name@company.com"
                name="email"
                value={f.values.email}
                onChange={f.handleChange}
                onBlur={f.handleBlur}
              />
              {err("email")}
            </div>
            <div className="um-field">
              <label className="um-label">Contact Number <span className="um-req">*</span></label>
              <input
                className="um-input um-mono"
                type="text"
                placeholder="10-digit mobile"
                name="mobile_number"
                value={f.values.mobile_number}
                onChange={f.handleChange}
                onBlur={f.handleBlur}
              />
              {err("mobile_number")}
            </div>
            <div className="um-field">
              <label className="um-label">Role</label>
              <input type="text" name="role" value="subAdmin" readOnly className="um-input um-input--readonly" />
            </div>
            <div className="um-field">
              <label className="um-label">
                Designation
                <button
                  type="button"
                  className="um-addbtn"
                  title="Add designation"
                  onClick={() => setShowDesignationModal(true)}
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </button>
              </label>
              <ReactSelect
                options={designationData}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Designation"
                name="designation"
                onChange={(selectedOption) =>
                  f.setFieldValue("designation", selectedOption ? selectedOption.value : "")
                }
                value={designationData.find((item) => item.value === f.values.designation) || null}
              />
              {err("designation")}
            </div>
          </div>
        </div>

        {/* Access & Permissions */}
        <div className="um-card">
          <div className="um-card__head">
            <span className="um-card__icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </span>
            <div>
              <h3 className="um-card__title">Access &amp; Permissions</h3>
              <p className="um-card__sub">Control which modules and sub-modules this sub-admin can use.</p>
            </div>
          </div>
          <div className="um-card__body um-grid">
            <div className="um-field">
              <label className="um-label">Module</label>
              <ReactSelect
                isMulti
                options={moduleData}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Module"
                name="module_id"
                closeMenuOnSelect={false}
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions ? selectedOptions.map((item) => item.value) : [];
                  f.setFieldValue("module_id", selectedValues);
                }}
                value={moduleData.filter((item) => f.values.module_id.includes(item.value))}
              />
              {err("module_id")}
            </div>
            <div className="um-field">
              <label className="um-label">Sub Module</label>
              <ReactSelect
                isMulti
                options={subModuleData}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Sub Module"
                name="sub_module_id"
                closeMenuOnSelect={false}
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions ? selectedOptions.map((item) => item.value) : [];
                  f.setFieldValue("sub_module_id", selectedValues);
                }}
                value={subModuleData.filter((item) => f.values.sub_module_id.includes(item.value))}
              />
              {err("sub_module_id")}
            </div>
          </div>
        </div>

        <DesignationModal
          show={showDesignationModal}
          onClose={() => setShowDesignationModal(false)}
          onAddSize={handleAddDesignation}
        />

        {/* sticky action bar */}
        <div className="um-actions-bar">
          <div className="um-actions-bar__hint">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            An invite with login details will be emailed to the sub-admin.
          </div>
          <div className="um-actions-bar__btns">
            <button type="button" className="um-btn" onClick={() => Navigate(-1)}>
              Cancel
            </button>
            <button type="submit" className="um-btn um-btn--primary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Create Sub Admin
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserManagementAdd;
